export default class ProjectModelAttributeItem {
    status = 0;
    scope = "";
    type = "";
    code = "";
    name = "";
}
